export const isNow = (program: any, selectedDate?: string | Date): boolean => {
    if (!program) return false;

    const currentTime = Date.now();

    const startingTime = Number(program.startTime);
    const endingTime = Number(program.endTime);

    if (selectedDate) {
        const selected = new Date(selectedDate);
        const now = new Date();

        const isToday = selected.toDateString() === now.toDateString();

        if (!isToday) {
            return false;
        }
    }

    return startingTime <= currentTime && endingTime >= currentTime;
};
